module.exports = __webpack_public_path__ + "media/themes/konsultacje-online-d202abd5.jpg";